import {iosVhFix} from './utils/ios-vh-fix';
import {initModals} from './modules/modals/init-modals';
import {initCustomSelect} from './modules/form/init-custom-select';
import {initFormValidate} from './modules/form/init-form-validate';
import {initMenu} from './modules/init-menu';
import {initMoveTo} from './modules/init-moveto';
import {initAnimation} from './modules/init-animation';
import {initFlatpickr} from './modules/init-flatpickr';
import {initHoverSlider} from './modules/init-hover-slider';
import {initPayment} from './modules/init-payment';
import {observeFixed} from './utils/observe-fixed';
import {initScrollLoader} from './modules/init-scroll-loader';
import {initImageParallax} from './modules/init-image-parallax';
import {initAnimateBlocks} from './modules/init-animate-blocks';
import {initButtonHover} from './modules/init-button-hover';
import {initHiddenItems} from './modules/init-hidden-items';
import {initOffertaAccept} from './modules/form/init-offerta-accept';
import {initPartnersSlider} from './modules/init-partners-slider';
import {initRevSlider} from './modules/init-rev-slider';
import {initAccordion} from './modules/init-accordion';
import {initFaqLoad} from './modules/init-faq-load';
import {initFilters} from './modules/init-filters';
import {initVideos} from './modules/init-videos';
import {initArticlesSlider} from './modules/init-articles-slider';
import {initScrollSpy} from './modules/init-scroll-spy';
import {initSimpleTabs} from './modules/init-simple-tabs';
// import {initLocoScroll} from './modules/init-loco-scroll';

window.addEventListener('DOMContentLoaded', () => {
  iosVhFix();
  initMenu();
  initMoveTo();
  initAnimation();
  initAnimateBlocks();
});

// Modules
// все скрипты должны быть в обработчике 'DOMContentLoaded', но не все в 'load'
// в load следует добавить скрипты, не участвующие в работе первого экрана
window.addEventListener('load', () => {
  observeFixed();
  initModals();
  initCustomSelect();
  initFormValidate();
  // initFormPromocode();
  initPayment();
  initScrollLoader();
  initHoverSlider();
  initFlatpickr();
  initImageParallax();
  initButtonHover();
  initHiddenItems();
  initOffertaAccept();
  initPartnersSlider();
  initRevSlider();
  initAccordion();
  initFaqLoad();
  initFilters();
  initVideos();
  initArticlesSlider();
  initScrollSpy();
  initSimpleTabs();
  // initLocoScroll();
});

// ---------------------------------

// ❗❗❗ обязательно установите плагины eslint, stylelint, editorconfig в редактор кода.

// привязывайте js не на классы, а на дата атрибуты (data-validate)

// вместо модификаторов .block--active используем утилитарные классы
// .is-active || .is-open || .is-invalid и прочие (обязателен нейминг в два слова)
// .select.select--opened ❌ ---> [data-select].is-open ✔️

// выносим все в дата атрибуты
// url до иконок пинов карты, настройки автопрокрутки слайдера, url к json и т.д.

// для адаптивного JS используейтся matchMedia и addListener
// const breakpoint = window.matchMedia(`(min-width:1024px)`);
// const breakpointChecker = () => {
//   if (breakpoint.matches) {
//   } else {
//   }
// };
// breakpoint.addListener(breakpointChecker);
// breakpointChecker();

// используйте .closest(el)
